<script lang="ts">
    import { i18n } from "../../store"
</script>

<div class="container">
    <button
        on:click="{() => {
            // @ts-ignore
            window.ccShowBar()
        }}">{$i18n("Cookie-Einstellungen öffnen")}</button
    >
</div>
